
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as licenseAuthoritykKobw5MZWyzqci44YzjjyHoBlGvNfeXwhm5TDq5UpMcMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/licenseAuthority.vue?macro=true";
import { default as jobszfRdGfc80DswwcejHaa3030nvvHJkwfSQlujLQJaIKIMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/jobs.vue?macro=true";
import { default as pricingtOneTge1njznu4ECgyIHpR3lx688VyywZaGKvpjxLXMMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/pricing.vue?macro=true";
import { default as videoListing7vDkbd52zWEDtpYN7CNntslIG44iKBlVIRXKw1vucfcMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/videoListing.vue?macro=true";
import { default as videoDetailG6KZhffkLAkvTYQ0DMNivNU3Q8EpPqT9THMUHQWqidQMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/videoDetail.vue?macro=true";
import { default as jobFwiPVvayO441BZmkaB01TkgFIwHIooAMVDphDJTxd1wMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/job.vue?macro=true";
import { default as communitykHKGhwNQAQ6UTuV5k5Y8DNelgosH_kkDJCSUztu8_F0Meta } from "/baserow-saas/plugins/saas/web-frontend/pages/community.vue?macro=true";
import { default as integrationListingNWo1bm4PK_ldjxGSVG9QUb6zGFAn5avxgwuuYweYWlkMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/integrationListing.vue?macro=true";
import { default as loginc7eYM7oLsmcKql5ZWTagGdwIw_Jgd81HBCKA56QBd7MMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as mcpAuthorizeDhY_3UuSbGDqL2ZEMytM3_6AcZyV9SfUPqSiuxdOZe0Meta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/mcpAuthorize.vue?macro=true";
import { default as signupURC2iSom4kkJ35bo6TvYb0FO0fuK097B452QKG7nLj8Meta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPasswordnGTIy0X0leWIAMUHmpjsKZwC4Cb0dL4iiCvP3DThMe0Meta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as verifyEmailAddress5kRjVj8tme8a9F0l_bUtpgIvnhL3zOYyHn5OUc6ZI6YMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as loginWithSAMLMGs_w3ZIt0JPddvGLgcrscrm0Fbsg7s1P5X6K4hU730Meta } from "/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginError7XIwLHvWx8G7d_g_NmG5HH_Fq2HLN5l6GzCtz1qgQwsMeta } from "/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPagesKU0vpR5JUEOaWH41yklJflo1Kqi1GVTdlZdYGwPFhkIMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as allWorkspacesrAnloIAbFuCGW8kCbflCGxpoZttSA_gMTLlIl45LcAsMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/allWorkspaces.vue?macro=true";
import { default as recentlyViewedPuVH_mUzad5V2x7BNYXKIAzjEnlGKL7DrBBTh8aObv4Meta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/recentlyViewed.vue?macro=true";
import { default as workspace90jMZHjJnO4bHwB0RWjlirhGZ_tTCLnXhqudtCEhr6oMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsDi_2To3mzhTThUILcOuiQEbr1_wMWZC0chNCDdPamAYMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as aiProvidersN6jcTU7_NkyiRnVpWHTmUKbKPDM3oSf3u2HFZ9hWopYMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/aiProviders.vue?macro=true";
import { default as health5NWD5RVj6gK_iZS_6b1UHNtgV52eXGYaItwPvZwmojkMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardl8adcULAM1KlPAmhD5cEErHfoTRdoOt7xOBbXiJynjAMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as usersdroA8usfMOkDnNToj5UkMvlWfHvWxrXq_QUTKz3TZ24Meta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspaces__zehLZV49MYWedYh5mnFJ92NZyklu0zK0L7s4mjYVYMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as viewsyOeOpQ_YXa3D_HMEpFyvn7WQdMY8__PeLGEOO482VRgMeta } from "/baserow-saas/baserow/web-frontend/modules/database/pages/admin/views.vue?macro=true";
import { default as authProvidersHrG4XTyCy97UTDbmaAxj6RQ2ZhFMGVYszQes7IypU10Meta } from "/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLogB_NvmPhlBKmgeY7lZzuUsnTRpMfY6GxiWxm_c1x5cdwMeta } from "/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue?macro=true";
import { default as dataScannerBD_3fCrg02Hb6eBQL29LBa9heZdP_5C3t5iuwUEaOVkMeta } from "/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue?macro=true";
import { default as subscriptionsC4g98zNJvotG6RjX4ScYOi9m4VaIyoXM8GNPTNdH6dQMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/subscriptions.vue?macro=true";
import { default as newSubscriptioncRgNROsIfHB8MsBL3pHladU8EIn47MY1SJ7PuvvrojsMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/newSubscription.vue?macro=true";
import { default as subscriptionD9CTRqCy9V6h4SeCn8GGxtxnKrvg_IfT3hCxqSdOH0wMeta } from "/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/subscription.vue?macro=true";
import { default as root6pdljLOuVbTfmFZy7PeWBG_38yS2d_C34BxkBRC3llYMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as template5feU7bc5iyUtQHMY4X1vRFHB1mhj_29VBh6RsQRXXxcMeta } from "/baserow-saas/baserow/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as tablefq_xtI_wKk_1REaNxByZ_mAJQo6_UqcH3vkrmUnhXGwMeta } from "/baserow-saas/baserow/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as APIDocsJ4PWkyGBmRu9fMiTdbicshsTS1ghtfkuBhdkjIATVMcMeta } from "/baserow-saas/baserow/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as publicViewLogin_JCEl0lBxGi_nACL0lxuVvacBNGKmPc5CIEQfE0RLpEMeta } from "/baserow-saas/baserow/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboardeaRskdVYFEg_G7gfVjB2LQoXWR10WCPovnrrgLL8NtkMeta } from "/baserow-saas/baserow/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as publicDashboardAuthESfgoKGtprv26LebC8qg3hVLYkhAUajlIAqawiomah4Meta } from "/baserow-saas/baserow/web-frontend/modules/dashboard/pages/publicDashboardAuth.vue?macro=true";
import { default as agentYh80IzAw13nbykDqEXrJ46AES_YWtGs__PazL0hAYmMMeta } from "/baserow-saas/baserow/web-frontend/modules/agent/pages/agent.vue?macro=true";
import { default as pageEditorfUElO_0BnsXI74N579iJakuPVaOyFSbN_ADb7TjUYDsMeta } from "/baserow-saas/baserow/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as automationWorkflowDpAI9TtHYnTpaDWKPD3juTmEmn2HzhGmJQM1MmiQWyEMeta } from "/baserow-saas/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as licensesGOfsjihKcBuQBeqficr4NSURi_VNqzeAKS3Z_W_71okMeta } from "/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue?macro=true";
import { default as licensehkvZ0jbOojoJP5X244jQeXsz_MLpb7jt20uGxn9OJ5QMeta } from "/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue?macro=true";
import { default as rootZaMgjz4SyadEMOXwI9aV_o3scxVjaenAOQ5SYGfDsB4Meta } from "/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "admin-license-authority",
    path: "/admin/license-authority",
    meta: { ...(licenseAuthoritykKobw5MZWyzqci44YzjjyHoBlGvNfeXwhm5TDq5UpMcMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/licenseAuthority.vue")
  },
  {
    name: "dev-docs",
    path: "/docs/:path(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/devDocs.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/contact.vue")
  },
  {
    name: "contact-sales",
    path: "/contact-sales",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/contactSales.vue")
  },
  {
    name: "privacy",
    path: "/privacy-policy",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/privacy.vue")
  },
  {
    name: "terms",
    path: "/terms-and-conditions",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/terms.vue")
  },
  {
    path: "/terms/subscription",
    redirect: {"name":"terms"}
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: jobszfRdGfc80DswwcejHaa3030nvvHJkwfSQlujLQJaIKIMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/jobs.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/faq.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingtOneTge1njznu4ECgyIHpR3lx688VyywZaGKvpjxLXMMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/pricing.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/templateListing.vue")
  },
  {
    name: "template-detail",
    path: "/templates/:slug",
    meta: {"middleware":"settings"},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/templateDetail.vue")
  },
  {
    name: "videos",
    path: "/videos",
    meta: videoListing7vDkbd52zWEDtpYN7CNntslIG44iKBlVIRXKw1vucfcMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/videoListing.vue")
  },
  {
    name: "video-detail",
    path: "/videos/:slug",
    meta: videoDetailG6KZhffkLAkvTYQ0DMNivNU3Q8EpPqT9THMUHQWqidQMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/videoDetail.vue")
  },
  {
    name: "license-redirect",
    path: "/get-license/:instanceId",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/licenseRedirect.vue")
  },
  {
    name: "job",
    path: "/jobs/:slug([a-zA-Z0-9 _-]+)",
    meta: jobFwiPVvayO441BZmkaB01TkgFIwHIooAMVDphDJTxd1wMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/job.vue")
  },
  {
    name: "blog",
    path: "/blog/",
    meta: {"category":"all","page":1},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/blog.vue")
  },
  {
    name: "blog-filtered",
    path: "/blog/category/:category([a-zA-Z0-9 _-]+)/:page([0-9]+)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/blog.vue")
  },
  {
    name: "blog-post-page",
    path: "/blog/:blogPostSlug([a-zA-Z0-9 _-]+)",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/blog/blogPage.vue")
  },
  {
    name: "user-docs",
    path: "/user-docs/:slug(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/userDocs.vue")
  },
  {
    name: "community",
    path: "/community",
    meta: communitykHKGhwNQAQ6UTuV5k5Y8DNelgosH_kkDJCSUztu8_F0Meta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/community.vue")
  },
  {
    name: "integrations",
    path: "/product/integrations",
    meta: integrationListingNWo1bm4PK_ldjxGSVG9QUb6zGFAn5avxgwuuYweYWlkMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/integrationListing.vue")
  },
  {
    name: "product",
    path: "/product/:product(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "solutions",
    path: "/solutions/:product(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "department",
    path: "/departments/:department(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "compliance",
    path: "/compliance/:compliance(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "industry",
    path: "/industries/:industry(.*)?",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "academy",
    path: "/academy",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/cmsPage.vue")
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/partners.vue")
  },
  {
    name: "partners-apply",
    path: "/partners/apply",
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/becomePartner.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPagesKU0vpR5JUEOaWH41yklJflo1Kqi1GVTdlZdYGwPFhkIMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginc7eYM7oLsmcKql5ZWTagGdwIw_Jgd81HBCKA56QBd7MMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "mcp-authorize",
    path: "/mcp-authorize/:request?",
    meta: mcpAuthorizeDhY_3UuSbGDqL2ZEMytM3_6AcZyV9SfUPqSiuxdOZe0Meta || {},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/mcpAuthorize.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupURC2iSom4kkJ35bo6TvYb0FO0fuK097B452QKG7nLj8Meta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordnGTIy0X0leWIAMUHmpjsKZwC4Cb0dL4iiCvP3DThMe0Meta || {},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddress5kRjVj8tme8a9F0l_bUtpgIvnhL3zOYyHn5OUc6ZI6YMeta || {},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLMGs_w3ZIt0JPddvGLgcrscrm0Fbsg7s1P5X6K4hU730Meta || {},
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginError7XIwLHvWx8G7d_g_NmG5HH_Fq2HLN5l6GzCtz1qgQwsMeta || {},
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(root6pdljLOuVbTfmFZy7PeWBG_38yS2d_C34BxkBRC3llYMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "all-workspaces",
    path: "/all-workspaces",
    meta: { ...(allWorkspacesrAnloIAbFuCGW8kCbflCGxpoZttSA_gMTLlIl45LcAsMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/allWorkspaces.vue")
  },
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: {"name":"all-workspaces"}
  },
  {
    name: "recently-viewed",
    path: "/recently-viewed",
    meta: { ...(recentlyViewedPuVH_mUzad5V2x7BNYXKIAzjEnlGKL7DrBBTh8aObv4Meta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/recentlyViewed.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspace90jMZHjJnO4bHwB0RWjlirhGZ_tTCLnXhqudtCEhr6oMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(settingsDi_2To3mzhTThUILcOuiQEbr1_wMWZC0chNCDdPamAYMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-ai-providers",
    path: "/admin/ai-providers",
    meta: { ...(aiProvidersN6jcTU7_NkyiRnVpWHTmUKbKPDM3oSf3u2HFZ9hWopYMeta || {}), ...{"middleware":["staff","staff"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/aiProviders.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(health5NWD5RVj6gK_iZS_6b1UHNtgV52eXGYaItwPvZwmojkMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: { ...(dashboardl8adcULAM1KlPAmhD5cEErHfoTRdoOt7xOBbXiJynjAMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(usersdroA8usfMOkDnNToj5UkMvlWfHvWxrXq_QUTKz3TZ24Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    meta: { ...(workspaces__zehLZV49MYWedYh5mnFJ92NZyklu0zK0L7s4mjYVYMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    path: "invites",
    name: "settings-invites-redirect",
    redirect: {"name":"settings-members"}
  },
  {
    name: "settings-agents",
    path: "agents",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/settings/agents.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-database-views",
    path: "/admin/database-views",
    meta: { ...(viewsyOeOpQ_YXa3D_HMEpFyvn7WQdMY8__PeLGEOO482VRgMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/admin/views.vue")
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProvidersHrG4XTyCy97UTDbmaAxj6RQ2ZhFMGVYszQes7IypU10Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLogB_NvmPhlBKmgeY7lZzuUsnTRpMfY6GxiWxm_c1x5cdwMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "admin-data-scanner",
    path: "/admin/data-scanner",
    meta: { ...(dataScannerBD_3fCrg02Hb6eBQL29LBa9heZdP_5C3t5iuwUEaOVkMeta || {}), ...{"middleware":"staff"} },
    redirect: "/admin/data-scanner/scans",
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue"),
    children: [
  {
    name: "admin-data-scanner-scans",
    path: "scans",
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue")
  },
  {
    name: "admin-data-scanner-results",
    path: "results",
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue")
  }
]
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    meta: { ...(auditLogB_NvmPhlBKmgeY7lZzuUsnTRpMfY6GxiWxm_c1x5cdwMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/baserow-saas/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "subscriptions",
    path: "subscriptions",
    meta: subscriptionsC4g98zNJvotG6RjX4ScYOi9m4VaIyoXM8GNPTNdH6dQMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/subscriptions.vue")
  },
  {
    name: "new-subscription",
    path: "subscriptions/new/:instanceId?",
    meta: newSubscriptioncRgNROsIfHB8MsBL3pHladU8EIn47MY1SJ7PuvvrojsMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/newSubscription.vue")
  },
  {
    name: "subscription",
    path: "subscriptions/:subscriptionId",
    meta: subscriptionD9CTRqCy9V6h4SeCn8GGxtxnKrvg_IfT3hCxqSdOH0wMeta || {},
    component: () => import("/baserow-saas/plugins/saas/web-frontend/pages/subscriptions/subscription.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    meta: template5feU7bc5iyUtQHMY4X1vRFHB1mhj_29VBh6RsQRXXxcMeta || {},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: {"middleware":["settings","authenticated","redirectCompletedOnboarding","settings","authenticated","redirectCompletedOnboarding"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tablefq_xtI_wKk_1REaNxByZ_mAJQo6_UqcH3vkrmUnhXGwMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: APIDocsJ4PWkyGBmRu9fMiTdbicshsTS1ghtfkuBhdkjIATVMcMeta || {},
    alias: ["/api/docs"],
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLogin_JCEl0lBxGi_nACL0lxuVvacBNGKmPc5CIEQfE0RLpEMeta || {}), ...{"layout":"login"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboardeaRskdVYFEg_G7gfVjB2LQoXWR10WCPovnrrgLL8NtkMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectDashboard","settings","authenticated","workspacesAndApplications","selectDashboard"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "dashboard-public",
    path: "/public/dashboard/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/dashboard/pages/publicDashboard.vue")
  },
  {
    name: "dashboard-public-auth",
    path: "/public/dashboard/:slug/auth",
    meta: { ...(publicDashboardAuthESfgoKGtprv26LebC8qg3hVLYkhAUajlIAqawiomah4Meta || {}), ...{"layout":"login"} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/dashboard/pages/publicDashboardAuth.vue")
  },
  {
    name: "agent-application",
    path: "/agent/:agentId",
    meta: { ...(agentYh80IzAw13nbykDqEXrJ46AES_YWtGs__PazL0hAYmMMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectAgentApplication","settings","authenticated","workspacesAndApplications","selectAgentApplication"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/agent/pages/agent.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorfUElO_0BnsXI74N579iJakuPVaOyFSbN_ADb7TjUYDsMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true,"previewBuilderRoute":true},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/preview/:builderId/:pathMatch(.*)*",
    meta: {"previewBuilderRoute":true,"middleware":["exchangePreviewToken","userSourceAuthProviderCallback"],"builderPageMode":"preview"},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "application-builder-published",
    path: "/builder/published/:builderId/:pathMatch(.*)*",
    meta: {"middleware":["userSourceAuthProviderCallback"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true,"middleware":["userSourceAuthProviderCallback"]},
    component: () => import("/baserow-saas/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowDpAI9TtHYnTpaDWKPD3juTmEmn2HzhGmJQM1MmiQWyEMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "premium-root",
    path: "",
    meta: { ...(rootZaMgjz4SyadEMOXwI9aV_o3scxVjaenAOQ5SYGfDsB4Meta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue"),
    children: [
  {
    name: "admin-licenses",
    path: "/admin/licenses",
    meta: { ...(licensesGOfsjihKcBuQBeqficr4NSURi_VNqzeAKS3Z_W_71okMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue")
  },
  {
    name: "admin-license",
    path: "/admin/license/:id",
    meta: { ...(licensehkvZ0jbOojoJP5X244jQeXsz_MLpb7jt20uGxn9OJ5QMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow-saas/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue")
  }
]
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  }
]